import {ChildPortDirectionChunk} from "../../chunks/types/ChildPortDirectionChunk";
import {PortDirection} from "../types/PortDirection";

export function getPortDirectionFromChildPortDirectionChunk(
  childPortDirectionChunk: ChildPortDirectionChunk
): PortDirection {
  const {
    captures: [childPortDirection]
  } = childPortDirectionChunk;
  return {
    ["in" as string]: PortDirection.input,
    ["out" as string]: PortDirection.output
  }[childPortDirection];
}
